module.exports = {
      id: "ios-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#ios",
      toString: function () {
        return this.url;
      }
    }